import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/ro';
import 'moment/locale/th';
import 'moment/locale/hr';
import 'moment/locale/pt';
import { TIME_FORMAT_SHORT } from 'app/types/constants';
import { formatUTCInLocal } from 'util/formatting';
import { SENDER_COLORS } from './constants';

export const getSenderColor = (senderID) => SENDER_COLORS[senderID % SENDER_COLORS.length];

export const getDateKey = (dateStr) => {
  const d = moment.utc(dateStr).local();
  return `${d.year()}-${d.month()}-${d.date()}`;
};

export const formatDateLabel = (dateStr, formatMessage, locale = 'en') => {
  const date = moment.utc(dateStr).local().locale(locale);
  const today = moment().startOf('day');
  const yesterday = moment().subtract(1, 'day').startOf('day');

  if (date.isSame(today, 'day')) return formatMessage({ id: 'today' });
  if (date.isSame(yesterday, 'day')) return formatMessage({ id: 'yesterday' });
  if (date.isSame(today, 'year')) return date.format('ddd, D MMM');
  return date.format('D MMM YYYY');
};

export const formatMessageTime = (dateStr) => formatUTCInLocal(dateStr, TIME_FORMAT_SHORT);

export const formatChannelListTime = (dateStr, formatMessage, locale = 'en') => {
  if (!dateStr) return '';
  const d = moment.utc(dateStr).local().locale(locale);
  const now = moment();
  if (d.isSame(now, 'day')) return d.format(TIME_FORMAT_SHORT);
  if (d.isSame(now.clone().subtract(1, 'day'), 'day')) return formatMessage({ id: 'yesterday' });
  if (d.isAfter(now.clone().subtract(7, 'days'), 'day')) return d.format('ddd');
  if (d.isSame(now, 'year')) return d.format('D MMM');
  return d.format('D MMM YYYY');
};

const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const splitByQuery = (text, query) => {
  if (!text || !query) return [{ text, match: false }];
  const words = query.replace(/\W+/g, ' ').trim().split(/\s+/).filter((w) => w.length > 0);
  if (words.length === 0) return [{ text, match: false }];
  const pattern = words.map(escapeRegExp).join('\\W*');
  const re = new RegExp(pattern, 'gi');

  const result = [];
  let lastIndex = 0;
  let m;
  while ((m = re.exec(text)) !== null) {
    if (m.index > lastIndex) {
      result.push({ text: text.slice(lastIndex, m.index), match: false });
    }
    result.push({ text: m[0], match: true });
    lastIndex = m.index + m[0].length;
    if (m[0].length === 0) re.lastIndex++;
  }
  if (lastIndex < text.length) {
    result.push({ text: text.slice(lastIndex), match: false });
  }
  return result.length ? result : [{ text, match: false }];
};
